// extracted by mini-css-extract-plugin
module.exports = {"descriptionContainer":"AykU_y","descriptionTitle":"ma-GxC","icon":"xeBd8K","description":"Sic9I6","expanded":"JDGdMF","folded":"CVxotq"};